import { defineComponent as _defineComponent } from 'vue'
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcModal.ts.vue';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { computed, ref } from 'vue';

interface Props {
  isModalOpen: boolean;
  modalTitle?: string;
  modalDescription?: string;
}

interface Emits {
  (event: 'onCancel'): void;
  (event: 'onSave', value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcManualLocationAddModal.ts',
  props: {
    isModalOpen: { type: Boolean },
    modalTitle: null,
    modalDescription: null
  },
  emits: ["onCancel", "onSave"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'onCancel'): void;
  (event: 'onSave', value: string): void;
}), expose: any, slots: any, attrs: any }) {





const locationsList = ref<string>('');

const disabledMessage = computed(() => {
  if (!locationsList.value) {
    return 'Please complete the field to submit.';
  }

  return '';
});

function onSaveClick() {
  emits('onSave', locationsList.value);
}

function onModalClose() {
  locationsList.value = '';
  emits('onCancel');
}

return { __sfc: true,emits, locationsList, disabledMessage, onSaveClick, onModalClose, CcCardItem, CcModal, CardLayer }
}

})